import {types} from "mobx-state-tree";
import dashboardModel from "./dashboardsModel";
import {rootFilterModel} from "./wdRootFilter";

const RootStore = types.model({
    dashboard: dashboardModel,
    rootFilter: rootFilterModel,
})

const rootStore = RootStore.create({
    dashboard: {name: "main"},
    rootFilter: {items: []},
})

export default rootStore
